<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getWorkOrderSupplySubContracts"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-material-issue-number" label-cols-sm="4" label-cols-lg="3" label="Material Issue Number" label-for="filter-material-issue-number" size="sm" :model.sync="filter.materialIssueNumber" />
					<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Subcontract Purchase Order" id="filter-" size="sm" :model.sync="filter.purchaseOrderId" @input="getPurchaseOrders" @focus="getPurchaseOrders" />
					<app-input-datepicker-range  id="fieldset-material-issue-date" label-cols-sm="4" label-cols-lg="3" label="Material Issue Date" size="sm" :modelFrom.sync="filter.materialIssueDateFrom" :modelTo.sync="filter.materialIssueDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<!-- <app-input-textbox id="fieldset-revisi" label-cols-sm="4" label-cols-lg="3" label="Revisi" label-for="filter-revisi" size="sm" :model.sync="filter.revisi" /> -->
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="wosForSubcontractStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Supply Subcont Status" id="filter-" size="sm" :model.sync="filter.wosSubcontStatusId" @input="getWosForSubcontractStatuss" @focus="getWosForSubcontractStatuss" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Vendor" id="filter-" size="sm" :model.sync="filter.vendorId" @input="getVendors" @focus="getVendors" />
					<app-input-textarea id="fieldset-remarks" label-cols-sm="4" label-cols-lg="3" label="Remarks" label-for="filter-remarks" size="sm" :model.sync="filter.remarksMultiple" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getWorkOrderSupplySubContracts"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Work Order Supply Sub Contract</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/workordersupplysubcontract/WorkOrderSupplySubContract.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="false"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-workordersupplysubcontract" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="workOrderSupplySubContracts" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="workOrderSupplySubContracts.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Material Issue Number" class="table-filter">
					<b-form-input id="input-material-issue-number-table" @input="getWorkOrderSupplySubContractsWithoutLoading" v-model="filter.materialIssueNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Subcontract Purchase Order" class="table-filter">
					<v-select append-to-body label="purchaseOrderNumber" :options="purchaseOrders" :value="filter.purchaseOrderId" :reduce="item => item.id" v-model="filter.purchaseOrderId" :filterable="true" @input="getWorkOrderSupplySubContractsWithoutLoading" @search="getPurchaseOrders"></v-select>
				</b-th>
				<b-th stacked-heading="Material Issue Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-material-issue-date-from-table" reset-button @input="getWorkOrderSupplySubContractsWithoutLoading" v-model="filter.materialIssueDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-material-issue-date-to-table" reset-button @input="getWorkOrderSupplySubContractsWithoutLoading" v-model="filter.materialIssueDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Revisi" class="table-filter">
					<b-form-input id="input-revisi-table" @input="getWorkOrderSupplySubContractsWithoutLoading" v-model="filter.revisi" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Work Order Supply Subcont Status" class="table-filter">
					<v-select append-to-body label="name" :options="wosForSubcontractStatuss" :value="filter.wosSubcontStatusId" :reduce="item => item.id" v-model="filter.wosSubcontStatusId" :filterable="true" @input="getWorkOrderSupplySubContractsWithoutLoading" @search="getWosForSubcontractStatuss"></v-select>
				</b-th>
				<b-th stacked-heading="Vendor" class="table-filter">
					<v-select append-to-body label="code" :options="vendors" :value="filter.vendorId" :reduce="item => item.id" v-model="filter.vendorId" :filterable="true" @input="getWorkOrderSupplySubContractsWithoutLoading" @search="getVendors"></v-select>
				</b-th>
				<b-th stacked-heading="Remarks" class="table-filter">
					<b-form-input id="input-remarks-table" @input="getWorkOrderSupplySubContractsWithoutLoading" v-model="filter.remarks" size="sm"></b-form-input>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(materialissuenumber)="row">

                <a @click="() => ( $router.push({ name: 'workordersupplysubcontractdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.materialIssueNumber != null && row.item.materialIssueNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.materialIssueNumber.slice(0, 30) + (row.item.materialIssueNumber.length > 30 ? "..." : "" ) : row.item.materialIssueNumber : "" }}
						</a>
            
					</template>

			<template v-slot:cell(purchaseOrder)="row">
				{{ row.item.purchaseOrder != null ? row.item.purchaseOrder.purchaseOrderNumber : "" }}
			</template>
			<template v-slot:cell(materialIssueDate)="row">
				{{ row.item.materialIssueDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(wosSubcontStatus)="row">
				{{ row.item.wosSubcontStatus != null ? row.item.wosSubcontStatus.name : "" }}
			</template>
			<template v-slot:cell(vendor)="row">
				{{ row.item.vendor != null ? row.item.vendor.code : "" }}
			</template>
				<template v-slot:cell(remarks)="row">
					<app-long-text  :id="'remarks-' + row.index" :text="row.item != null ? (row.item.remarks != null && row.item.remarks != '' ? row.item.remarks : '') : ''" />
				</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="false">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-datepicker  id="fieldset-material-issue-date" label-cols-lg="12"  label="Material Issue Date" size="sm" :model.sync="row.item.materialIssueDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-revisi" label-cols-lg="12"  label="Revisi" label-for="input-revisi" size="sm" :model.sync="row.item.revisi"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.wosSubcontStatusId" label="Work Order Supply Subcont Status" :selected="row.item.wosSubcontStatus != null ? row.item.wosSubcontStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.vendorId" label="Vendor" :selected="row.item.vendor != null ? row.item.vendor.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="row.item.remarks"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(workOrderSupplySubContractsPaging != null ? workOrderSupplySubContractsPaging.dataCount : 0)"
									:per-page="(workOrderSupplySubContractsPaging != null ? workOrderSupplySubContractsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-workordersupplysubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-workordersupplysubcontract.b-table>thead>tr>th {
	background: #e28b29;
}

    ::v-deep #table-list-workordersupplysubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import WorkOrderSupplySubContractList from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractList';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import WosForSubcontractStatusFilter from '@/filters/WosForSubcontractStatus/WosForSubcontractStatusFilter';
import WosForSubcontractStatus from '@/models/WosForSubcontractStatus/WosForSubcontractStatus';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import PartMappingSubcontractFilter from '@/filters/PartMappingSubcontract/PartMappingSubcontractFilter';
import PartMappingSubcontract from '@/models/PartMappingSubcontract/PartMappingSubcontract';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		WorkOrderSupplySubContract, 
		WorkOrderSupplySubContractList, 
		WorkOrderSupplySubContractFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"materialIssueNumber": {}, "class" : "th-material-issue-number first-child", "label" : "Material Issue Number", key: 'materialIssueNumber', sortable: true}, 
				{"purchaseOrder": {}, "class" : "th-purchase-order", "label" : "Subcontract Purchase Order", key: 'purchaseOrder', sortable: true}, 
				{"materialIssueDate": {}, "class" : "th-material-issue-date last-child", "label" : "Material Issue Date", key: 'materialIssueDate', sortable: true}, 
				{"revisi": {}, "class" : "th-revisi d-stack-none", "label" : "Revisi", key: 'revisi', sortable: true}, 
				{"wosSubcontStatus": {}, "class" : "th-wos-subcont-status d-stack-none", "label" : "Work Order Supply Subcont Status", key: 'wosSubcontStatus', sortable: true}, 
				{"vendor": {}, "class" : "th-vendor d-stack-none", "label" : "Vendor", key: 'vendor', sortable: true}, 
				{"remarks": {}, "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			workOrderSupplySubContracts: [],
			workOrderSupplySubContractsPaging: {},
			purchaseOrders : [],
			wosForSubcontractStatuss : [],
			vendors : [],
			workOrderSupplySubContractDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			
		}
	},	
	methods : {
		getWorkOrderSupplySubContracts : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			await WorkOrderSupplySubContract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data;
					this.workOrderSupplySubContractsPaging = result;
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderSupplySubContractsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			WorkOrderSupplySubContract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data
					this.workOrderSupplySubContractsPaging = result
				}
			})
			.catch(error => {});
		},
		getPurchaseOrders : async function(input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			await PurchaseOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrders = result.data
				}
			})
			.catch(error => {});
		},
		getWosForSubcontractStatuss : async function(input) {
			let filter = new WosForSubcontractStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await WosForSubcontractStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.wosForSubcontractStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new WorkOrderSupplySubContractFilter();
			this.getWorkOrderSupplySubContracts();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getWorkOrderSupplySubContracts();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				WorkOrderSupplySubContract.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			WorkOrderSupplySubContract.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			WorkOrderSupplySubContract.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			WorkOrderSupplySubContract.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'workordersupplysubcontractedit';
						if(this.isScannerMode) {
							createRoute = 'workordersupplysubcontractscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			WorkOrderSupplySubContract.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workordersupplysubcontractedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			WorkOrderSupplySubContract.deleteData(this, id).then(result => {
				if (result)
				{
					this.getWorkOrderSupplySubContracts();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				WorkOrderSupplySubContract.deleteMultipleData(this).then(result => {
					this.getWorkOrderSupplySubContracts();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableWorkOrderSupplySubContractParent = document.getElementById('table-list-workordersupplysubcontract').parentNode;
			tableWorkOrderSupplySubContractParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableWorkOrderSupplySubContractParent.scrollWidth - tableWorkOrderSupplySubContractParent.offsetWidth) == Math.ceil(tableWorkOrderSupplySubContractParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableWorkOrderSupplySubContractParent = document.getElementById('table-list-workordersupplysubcontract').parentNode;
			tableWorkOrderSupplySubContractParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableWorkOrderSupplySubContractParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new WorkOrderSupplySubContractFilter();
		this.getPurchaseOrders()
		this.getWosForSubcontractStatuss()
		this.getVendors()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Work Order Supply Sub Contract"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getWorkOrderSupplySubContracts();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getWorkOrderSupplySubContracts();
			}
		},
		sortDesc: {
			handler: function() {
				this.getWorkOrderSupplySubContracts();
			}
		},
		currentPage: {
			handler: function() {
				this.getWorkOrderSupplySubContracts();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getWorkOrderSupplySubContracts();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				WorkOrderSupplySubContract.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "workordersupplysubcontractindex") {
					this.getWorkOrderSupplySubContractsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "work_order_supply_sub_contract").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
